// extracted by mini-css-extract-plugin
module.exports = {"card":"CategoryPosts_card__897bn","wrapper":"CategoryPosts_wrapper__xwLnt"};